/** Invalidates pending work when the session changes or the provider unmounts. */
export function createRequestVersion() {
  let version = 0
  return {
    next() {
      const current = ++version
      return () => current === version
    },
    invalidate() {
      version++
    },
  }
}
